import axios from "axios";
//const API_URL = 'https://apialunorte.kairosmining.com/auth/'
const API_URL = 'https://apikairos.kairosmining.com/auth/'
// const API_URL = 'http://localhost:5000/auth/';

const register = (username, email, password) => {
  return axios.post(API_URL + "signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  return axios
    .post(API_URL + "login", { Usuario: username, Password: password })
    .then((response) => {
      if (response.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      //console.log(response)
      return response;
    }).catch((error) => {
      console.log(error.response.data);
      return error.response.data;
    });
};

const changePassword = (idUser, oldPass, newPass) => {
  return axios
    .post(API_URL + "changePassword", {
      idUser: idUser,
      oldPass: oldPass,
      newPass: newPass,
    })
    .then((response) => {
      // console.log(response);
      if (response.data) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response;
    }).catch((error) => {
      // console.log(error.response.data);
      return error.response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const exportedObject = {
  register,
  login,
  logout,
  getCurrentUser,
  changePassword
}

export default exportedObject